const data = {
	"body": "<path fill=\"currentColor\" d=\"M2 5.56L2.413 5h11.194l.393.54L8.373 11h-.827L2 5.56z\"/>"
};
exports.__esModule = true;
exports.default = data;
